var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenukb = function SvgMenukb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.508 12.005a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M12.505 12.005a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M6.503 12.005a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
  })));
};
export { SvgMenukb as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZTJjZjJjZTg1OGJiNmIxZWYxNGM5MjdkOWIxM2RiZTMuc3ZnIjs=";